import { Divider, TextField, Box, Grid, Typography } from "@mui/material";
import { useState } from "react";
import AuthTypeText from "./AuthTypeText";
import TextFieldWithVariableTooltip from "components/Common/TextFieldWithVariableTooltip";

const BearerTokenAuthorization = ({
  authorization, onAuthorizationUpdate,
}) => {
  const [enteredToken, setEnteredToken] = useState(authorization?.token);

  const handleInputChange = (e) => {
    setEnteredToken(e.target.value);
  };

  const handleCollectionCall = async () => {
    await onAuthorizationUpdate({
      authorization_value: {
        token: enteredToken
      }
    });
  };

  return (
    <Box p={2}>
      <AuthTypeText />
      <Divider sx={{ my: 2 }} />

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={3}>
          <Typography variant="body" sx={{ color: 'var(--text-primary)' }}>Token:</Typography>
        </Grid>
        <Grid item xs={9}>
          <TextFieldWithVariableTooltip
            size="small"
            variant="outlined"
            value={enteredToken}
            onChange={handleInputChange}
            onBlur={handleCollectionCall}
            style={{ width: '40%' }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BearerTokenAuthorization;
